export enum JobInterfaceEnum {
  FETCH_JOB_SUCCESS = 'FETCH_JOB_SUCCESS',
  FETCH_JOB_FAILURE = 'FETCH_JOB_FAILURE',
}
